<template>
  <el-container class="baohus" >
    <el-row :style="{'width': screenWidth+'px','height': screenHeight+'px','background-color': '#fff'}">
      <h4 style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">神奇的槟榔</h4>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      小时侯读过苏东坡的这首诗，百思不得其解，为什么吃槟榔想吐又滋味甘甜﹑美妙绝伦呢？但从那时侯起我对槟榔就有一种向往，想体味一下它的美味。
      后来听过一个关于槟榔的美丽传说：相传很久很久以前，五指山下的一个黎寨里，住着一位名叫佰廖（黎语，意即美丽）的姑娘。
      她勤劳善良，心灵手巧，她织出的简裙，使美丽的孔雀都不敢开屏；她唱歌的时候，连百灵鸟都要屏息静听。
       
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      五指山下方圆几百里的青年人，都争先恐后地向她求婚。佰廖对他们说：”我不爱谁家财产，我只爱对爱情忠贞的人。
      如果谁把五指山顶的槟榔摘给我，谁就是我最爱的人。”许多求婚者听后畏怯而归。有一位名叫椰果的黎族猎手，深深地爱着佰廖，并勇敢地向五指山走去。
      他穿过了人迹罕至的原始森林，战服了野兽和山蚂蝗的袭击，终于攀上峰顶，摘回一束束槟榔果送给佰廖姑娘，与姑娘结为幸福夫妻。
      从那以后，当地人们便把槟榔作为定亲的信物，一旦男方看中某位姑娘，就要向女家送去槟榔果（俗称”放槟榔”）以示求婚，如果女方父母将赠来的槟榔盒打开，并拣一棵槟榔果来嚼，
      便是答应了婚事，否则便如数退还，表示推辞。结婚时，新娘还得请双方父母和乡亲吃槟榔。黎家妇女在生下女孩时，总要在自家门前种下一株槟榔树，到女孩长大出嫁时，
      这株树也要随之挖出，移植到男方家，直到她死后才砍掉，以示其人如槟榔树一般坚贞。
      
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      再以后又听了“高高的树上结槟榔，谁先爬上谁先尝”这首大陆和台湾都熟悉的情歌，这样更激起了我对槟榔的神往之情。要知道在我们那个年代，多多少少对爱情有些朦胧的感觉。
      槟榔还有药用价值呢。《名医别录》谓：“槟榔生南海，气味苦辛温涩、无毒，消谷逐水除痰辟，杀三虫，伏尸，寸白。”中医临床上常用以治痢疾、绦虫博胆道蛔虫、血吸虫病等。
      用槟榔制成溶液点眼，可治疗青光眼。五代医学家和文学家，对槟榔的药用价值推崇备至。宋•黄庭坚曾托人几觅槟榔：“蛮煤雨里红干树，逐水排痰肘后方，莫笑忍饥穷县令，
      烦君一斛寄槟榔”。宋•朱熹也赞其治疾杀虫之功。诗曰：“忆昔南游日，初尝面发红。药囊知有用，茗碗讵能同。蠲疾收殊效，修真录异功。三彭如不避，糜烂七非中。
      ”历代诗人吟咏槟榔的诗句甚多，如：唐•李白的“何如黄金盘，一斛荐槟榔”，宋•唐庚的“织贝流肌滑，槟榔入颊红”，元•张翥的“槟榔新善啖，一斛宿醒空”宋•苏轼的“不用长愁挂月村，
      槟榔生子竹生孙”……槟榔不仅是药物，也是海南岛黎族、苗族自治州民间喜庆之礼物。
      </p>
      <p style="width: 80%;text-align: left;margin-left: 10%;margin-right: 20%;margin-top: 1%;">
      喜庆节日，相互赠送，尤以婚期吉庆，不给喜糖尚可以，不送槟榔就是失礼。接待客人，总以槟榔招待：一片新鲜槟榔，一片木香树叶，再抹上贝壳浆糊，请您放在口中细嚼，
      以示盛意。读书时我对槟榔文化有了比较透彻的理解，更让我感到欣慰的是完成了一尝槟榔的夙愿。那次是在同学的生日宴会上，同学拿出几包槟榔让大家品尝。
      我们迫不及待的拿来一块放进口里，一嚼，哇，好苦！赶紧吐了出来，但朋友笑了，说：你慢慢嚼嚼吧，到时你就会发现其中的滋味的。
      我听了再拿来一块槟榔放进口里，这次没有原来苦了，再嚼嚼，还真有一丝甘甜。噫，还真神奇！
      </p>
     
     
    </el-row>
  </el-container>

</template>

<script>
  export default {
    data() {
      return {

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,

      };
    },
  }
</script>

<style>
  h2{
  		text-align: center;
  	}
  	p{
  		margin:0 0 0 25px;
  		line-height: 25px;
  	}
  	h4{
  		margin:5 0 5 0;
  	}


</style>



// WEBPACK FOOTER //
// src/components/main/binlang/1.vue